import React from 'react';
import styles from "../Footer.module.scss"

const Footer1 = () => {
    return (
        <>   

        <div className={styles.wrapper}>
        <div className={styles.container1}>
        <img className={styles.logo} src="/assets/nav-logo.svg" />
          <div className={styles.left}>
          <div className={styles.menuitem}>Wallet</div>
          <div className={styles.menuitem}>Exchange</div>
          </div>

          <div className={styles.rightmenu}>         
          <div className={styles.heading}>Download App</div>
          <img src="/assets/app-store.png" alt="App Store"/>
          </div>
          <img src="/assets/google-store.png" alt="google play" className={styles.img2}/>
          </div>
          </div>
        </>
    )
}

export default Footer1;

